import { createRef, FunctionComponent } from 'react';
import Type from '../../icons/ProgramType';
import Format from '../../icons/Format';
import Hours from '../../icons/Hours';
import Age from '../../icons/Age';
import Requirements from '../../icons/Requirements';
import SaveButton from '../SaveButton';
import GetStartedButton from '../GetStartedButton';
import Program from 'wwg-utilities/dist/collections/program';
import getAgeRequirementsString from 'wwg-utilities/dist/sharedFunctions/getAgeRequirementsString';
import { isSkillup, isWhereWeGo } from '../../../lib/config/project/project';

interface QuickFactsProps {
  program: Program;
  region: string;
}

const QuickFacts: FunctionComponent<QuickFactsProps> = ({
  program,
  region,
}) => {
  const sidebarRef = createRef<HTMLDivElement>();
  return (
    <aside>
      <div
        ref={sidebarRef}
        className={`z-[9] mt-12 bg-sidebar rounded-sidebar text-sidebar-text h-fit relative w-full lg:w-96 p-10 lg:right-0  lg:-top-6 lg:mx-4`}
      >
        {Boolean(program.headline && !isSkillup) && (
          <div
            className="rounded-tr-5xl rounded-bl-5xl bg-white shadow-headline w-full  p-4 relative
            after:content-[''] after:block after:absolute after:right-8 after:border-t-white after:border-headline after:border-l-transparent
            after:border-r-white after:border-b-transparent after:-bottom-8 after:drop-shadow-headline mb-8
            "
          >
            <p className="text-lg font-bold font-heading text-purple">
              WWG Says
            </p>
            <p className="text-base italic text-purple font-heading">
              "{program.headline}"
            </p>
          </div>
        )}
        <div>
          <h3
            className={`font-heading text-2xl font-bold ${
              isWhereWeGo ? 'text-black' : ''
            }`}
          >
            Quick Facts
          </h3>
          <div className="grid items-center my-4 grid-cols-sidebar-icons">
            <Type className="fill-sidebar-icon" />
            <p
              className={`font-heading text-sm ${
                isWhereWeGo ? 'text-black' : ''
              }`}
            >
              Type: &nbsp;
              <span className="font-bold">{program.programType}</span>
            </p>
          </div>
          <div className="grid items-center my-4 grid-cols-sidebar-icons">
            <Format className="stroke-sidebar-icon fill-sidebar-icon" />
            <p
              className={`font-heading text-sm ${
                isWhereWeGo ? 'text-black' : ''
              }`}
            >
              Format: &nbsp;
              <span className="relative font-bold">
                {program.format.join(' ')}
                {program.format.includes('Hybrid') && (
                  <>
                    <img
                      src="https://res.cloudinary.com/wherewego/image/upload/v1652799228/project-connect/oqqvdi4kknyi6cvibeez.svg"
                      alt="White Background"
                      className="absolute w-3 h-3 cursor-pointer peer -top-1 -right-4"
                    />

                    <span className="tool-tip peer-hover:block transition-opacity duration-150 hidden absolute bottom-[30px] bg-white text-paragraph rounded-sm font-medium w-[200px] -left-4 p-2 font-base text-left text-xs shadow-sm">
                      Hybrid programs are done both online and in-person.
                    </span>
                  </>
                )}
              </span>
            </p>
          </div>
          <div className="grid items-center my-4 grid-cols-sidebar-icons">
            <Hours className="fill-sidebar-icon" />
            <p
              className={`font-heading text-sm ${
                isWhereWeGo ? 'text-black' : ''
              }`}
            >
              Hours: &nbsp;
              <span className="font-bold">{program.hours}</span>
            </p>
          </div>
          <div className="grid items-center my-4 grid-cols-sidebar-icons">
            <Age className="fill-sidebar-icon" />
            <p
              className={`font-heading text-sm ${
                isWhereWeGo ? 'text-black' : ''
              }`}
            >
              Age: &nbsp;
              <span className="font-bold">
                {getAgeRequirementsString(program.admissionRequirements)}
              </span>
            </p>
          </div>
          {Boolean(
            program.admissionRequirements?.requirements &&
              program.admissionRequirements?.requirements.length,
          ) && (
            <div className="grid items-center my-4 grid-cols-sidebar-icons">
              <Requirements className="fill-sidebar-icon" />
              <p
                className={`font-heading text-sm ${
                  isWhereWeGo ? 'text-black' : ''
                }`}
              >
                Requirements: &nbsp;
                <span className="font-bold">
                  {program.admissionRequirements?.requirements
                    ? program.admissionRequirements.requirements.join(', ')
                    : 'None'}
                </span>
              </p>
            </div>
          )}

          <div className="grid gap-4 sm:grid-cols-2">
            <SaveButton program={program} region={region} />
            <GetStartedButton location="top" program={program} />
          </div>
        </div>
      </div>
    </aside>
  );
};

export default QuickFacts;
